import React from "react";

interface EmailExistsModalProps {
  isOpen: boolean;
  email: string;
  onClose: () => void;
  onUseDifferentEmail: () => void;
  onCompleteExisting: () => void;
  onResetForm: () => void;
}

export const EmailExistsModal: React.FC<EmailExistsModalProps> = ({
  isOpen,
  email,
  onClose,
  onUseDifferentEmail,
  onCompleteExisting,
  onResetForm,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-orange-100 mb-4">
            <svg
              className="h-6 w-6 text-orange-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
              />
            </svg>
          </div>

          <h3 className="text-lg font-medium text-gray-900 mb-2">
            Email Already in Use
          </h3>

          <p className="text-sm text-gray-500 mb-6">
            The email <strong>{email}</strong> is already associated with an
            existing profile. You have two options:
          </p>

          <div className="space-y-3 mb-6">
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 text-left">
              <h4 className="font-medium text-blue-800 text-sm mb-1">
                Option 1: Complete Your Existing Profile
              </h4>
              <p className="text-xs text-blue-700">
                Continue working on your existing profile and complete the setup
                process.
              </p>
            </div>

            <div className="bg-green-50 border border-green-200 rounded-lg p-3 text-left">
              <h4 className="font-medium text-green-800 text-sm mb-1">
                Option 2: Use a Different Email
              </h4>
              <p className="text-xs text-green-700">
                Start fresh with a new email address for a different profile.
              </p>
            </div>
          </div>

          <div className="flex space-x-3">
            <button
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Cancel
            </button>
            <button
              onClick={onUseDifferentEmail}
              className="flex-1 px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
            >
              Change Email
            </button>
            <button
              onClick={onResetForm}
              className="flex-1 px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Reset Form
            </button>
            <button
              onClick={onCompleteExisting}
              className="flex-1 px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Complete Existing
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
